import { rootApi } from '../rootApi';

export const preAppHistoryReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({          // ← endpoints başlıyor
        getPreAppHistoryReport: builder.query({
            query: (body) => ({
                url: 'v1/preapphistoryreport/getlist',
                method: 'POST',
                body: {
                    pageSize:   body.pageSize   ?? 20,
                    pageNumber: body.pageNumber  ?? 1,
                    filters:    body.filters    ?? null,
                    sorts:      body.sorts      ?? null,
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items:         response.data.items,
                        totalCount:    response.data.totalCount    ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['PreAppHistoryReport']
        }),                              // ← getPreAppHistoryReport bitti, VIRGÜL var
        exportPreAppHistoryToExcel: builder.query({
            query: (body) => ({
                url: 'v1/preapphistoryreport/exporttoexcel',
                method: 'POST',
                body: {
                    filters:         body.filters         ?? null,
                    sorts:           body.sorts           ?? null,
                    LanguageId:      body.LanguageId,
                    compressionType: 0,
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export başarısız oldu');
            }
        })                               
    }),                                  
    overrideExisting: false
});

export const {
    useGetPreAppHistoryReportQuery,
    useLazyExportPreAppHistoryToExcelQuery
} = preAppHistoryReportApi;
